import Box from 'threads5/Box';

export default Box;
